import React from 'react';

import { observer } from 'mobx-react';

import classes from './NgzTopBar.module.scss';
import { angularizeWithProviders } from '../../providers';
import { usePageConfig } from '../../hooks/usePageConfig';
import { loggedInUserDataStore } from '../../stores/loggedInUserDataStore';
import { UserMenu } from './UserMenu/UserMenu';
import { Breadcrumbs } from './Breadcrumbs/Breadcrumbs';
import { HelpCenterButton } from '../../../guides-and-additional-info';

const NgzTopBar = observer(() => {
  const { loggedInUser, isEntity, isCoach, isSuperAdmin } = loggedInUserDataStore;
  const { hideNavigation } = usePageConfig();

  /* loggedInUser exist when fully login and when login as corporate account, need show top bar for logout action and other actions
   * for more info see docs/CORPORATE_ACCOUNTS.md
   */
  if (hideNavigation || !loggedInUser) {
    return null;
  }

  const isShowHelpCenter = isEntity || isCoach || isSuperAdmin;

  return (
    <header className={classes.topBar}>
      <Breadcrumbs />
      <div className={classes.actions}>
        {isShowHelpCenter && <HelpCenterButton />}
        {loggedInUser && <UserMenu />}
      </div>
    </header>
  );
});

angularizeWithProviders(NgzTopBar, 'ngzTopBar', {});

export { NgzTopBar };
